module.exports = __webpack_public_path__ + "static/media/step1-usa.9c511f87.png";